import { cn, Icons, Input, Label, Select, Table } from "@win-reality/react-ui";

import { useEventSchedulePage } from "./EventSchedule.hooks";
import { eventScheduleColumns } from "./EventScheduleTable.columns";

function EventSchedule() {
  const {
    complexOptions,
    selectedComplex,
    setSelectedComplex,
    monthOptions,
    selectedMonth,
    setSelectedMonth,
    rawSearchValue,
    setSearchValue,
    rows,
    isLoading,
  } = useEventSchedulePage();

  return (
    <div className={cn("flex flex-col gap-5 py-5 max-w-200 mx-auto")}>
      <div className="grid grid-cols-1 gap-4 px-5 md:grid-cols-2 lg:flex lg:flex-row">
        <div className="flex flex-col gap-2 md:col-span-2 lg:col-span-1 lg:grow">
          <Label className="text-sm mb-0">Search Events</Label>
          <Input
            type="text"
            name="event-search"
            id="event-search"
            placeholder="Search by event name..."
            value={rawSearchValue}
            isClearable
            onClear={() => setSearchValue("")}
            iconRight={
              <Icons.MagnifyingGlass className="h-5 w-5 text-placeholder" />
            }
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>

        <div className="flex flex-col gap-2 lg:min-w-50">
          <Label className="text-sm mb-0">Complex</Label>
          <Select
            items={complexOptions}
            value={selectedComplex}
            onValueChange={setSelectedComplex}
            placeholder="All"
          />
        </div>

        <div className="flex flex-col gap-2 lg:min-w-50">
          <Label className="text-sm mb-0">Timeframe</Label>
          <Select
            items={monthOptions}
            value={selectedMonth}
            onValueChange={setSelectedMonth}
          />
        </div>
      </div>

      <Table
        variant="infinite-scroll"
        data={rows}
        columns={eventScheduleColumns}
        isFetching={isLoading}
        rowClassName=" rounded"
        rowsWrapperClassName="gap-y-2"
        tableWrapperClassName="overflow-auto px-5 py-1"
        cellClassName="py-0 min-h-14"
      />
    </div>
  );
}

export { EventSchedule };
